



















import { Component, Prop, Vue } from "vue-property-decorator";

import SelectFrame from "./selectFrame/selectFrame.vue";
import ObjectList from "./objectList/objectList.vue";
// import ObjectListSlVueTree from "./objectListSlVueTree/objectListSlVueTree.vue";

import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { NameHelper } from "@/helper/nameHelper";

import ArrowLeft from "./resources/arrowLeft.vue";
import ArrowRight from "./resources/arrowRight.vue";

import { UserAgentHelper } from "@/helper/userAgentHelper"

@Component({
  components: {
    SelectFrame,
    ObjectList,
    // ObjectListSlVueTree,
    ArrowLeft,
    ArrowRight
  }
})
export default class SubController extends Vue {

  //  get isSlVueTreeVisible(){
  //   if(UserAgentHelper.getBrowser() == "ie"){
  //     return false
  //   }
  //   return true
  // }

  //↓↓↓↓↓↓↓↓↓↓サブコントローラー表示非表示↓↓↓↓↓↓↓↓↓↓
  @Prop()
  private isVisible!: boolean;

  openAnimate = false;
  open() {
    this.$emit("open");
    this.openAnimate = true;
    setTimeout(() => {
      this.openAnimate = false;
    }, 150);
  }

  closeAnimate = false;
  close() {
    this.closeAnimate = true;
    setTimeout(() => {
      this.$emit("close");
      this.closeAnimate = false;
    }, 150);
  }
  //↑↑↑↑↑↑↑↑↑↑サブコントローラー表示非表示↑↑↑↑↑↑↑↑↑↑↑

  selectFrameOpen = true;

  //↓↓↓↓↓↓↓↓↓↓オブジェクトリスト↓↓↓↓↓↓↓↓↓↓
  @Prop()
  private design!: Design;
  @Prop()
  private renameId!: string;

  // 新規グループレイヤー
  private newGroupLayer() {
    // グループレイヤー
    var groupLayer = GroupLayer.create();
    groupLayer.name = NameHelper.createLayerName("group", this.design);
    // 作成先
    var parent = this.getParentGroupLayer();
    this.onDoCommand("newLayer", { newLayer: groupLayer, parent: parent });
  }

  // 挿入先のグループレイヤーを取得する
  private getParentGroupLayer() {
    // 基本はデザインのトップ
    var parent = this.design.layer as GroupLayer;
    if (this.design.currentLayer != null) {
      if (this.design.currentLayer instanceof GroupLayer) {
        // カレントがグループの場合はそのレイヤー
        parent = this.design.currentLayer;
      } else {
        // カレントがある場合はその親レイヤー
        var parentOfCurrent = this.design.getParentLayer(
          this.design.currentLayer
        );
        if (parentOfCurrent != null) {
          parent = parentOfCurrent;
        }
      }
    }
    return parent;
  }

    //↑↑↑↑↑↑↑↑↑↑オブジェクトリスト↑↑↑↑↑↑↑↑↑↑↑

    private onDoCommand(command: string, paramater: any) {
        this.$emit("doCommand", command, paramater);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private editLayerName() {
        this.$emit("editLayerName")
    }

    private decideLayerName() {
        this.$emit("decideLayerName")
    }
}
